import React, { useRef } from 'react';

import { useSelector } from 'react-redux';

import { useFeatures } from '@atc/features';

import { AnalyticsEngine } from 'reaxl-analytics';

import { removeParameters } from '@/utilities/QueryStringUtil.js';

import contentAnalytics from '@/analytics/contentAnalyticsHandlers';
import globalAnalyticsHandlers from '@/analytics/globalAnalyticsHandlers';
import inventoryAnalytics from '@/analytics/inventoryAnalyticsHandlers';
import ownerAnalytics from '@/analytics/ownerAnalyticsHandlers';
import useAnalyticsPageEventListener from '@/analytics/useAnalyticsPageEventListener';
import useDataLayer from '@/analytics/useDataLayer';
import vdpAnalyticsHandlers from '@/analytics/vdpAnalyticsHandlers';

import birfDuck from '@/ducks/birfDuck.js';
import globalConfigsDuck from '@/ducks/globalConfigsDuck.js';

import CookieConsentModule from '@/modules/CookieConsentModule.js';

function VDPAnalytics() {

    const {
        thirdparty: [enableThirdParty],
        google_analytics: [, { disableGtm, disableGtmEvents, delay }],
        oneTrust: [isOneTrustEnabled],
    } = useFeatures([
        'thirdparty',
        'google_analytics',
        'oneTrust',
    ]);
    const hasSuppressedCookies = useSelector(CookieConsentModule.duck.selectors.selectHasSuppressedGroup) && isOneTrustEnabled;
    const analyticsPageEventListener = useAnalyticsPageEventListener();
    const dataLayer = useDataLayer();
    const dataIsland = useSelector(birfDuck.selectors.getPageData);
    const telmetricsKey = useSelector(globalConfigsDuck.selectors.getDuckState)?.telmetricsKey;
    const eventsSent = useRef(new Set());

    const analyticsProps = {
        disabled: hasSuppressedCookies,
        dataLayer: () => dataLayer,
        getDataIsland: () => dataIsland,
        instanceId: dataLayer?.page?.pixallPageInstanceId,
        eventListener: analyticsPageEventListener,
        google: {
            delay,
        },
        option: {
            disableGTM: disableGtm || !enableThirdParty,
            disablePixall: !enableThirdParty,
            disableGTMEvents: disableGtmEvents,
            telmetricsKey,
            onPageEventSent: (eventType, numberOfEvents) => {
                eventsSent.current.add(eventType);
                if (eventsSent.current.size === numberOfEvents) {
                    removeParameters('clickType');
                }
            },
        },
        value: {
            ...globalAnalyticsHandlers,
            ...inventoryAnalytics,
            ...ownerAnalytics,
            ...contentAnalytics,
            ...vdpAnalyticsHandlers,
        },
    };

    return (<AnalyticsEngine {...analyticsProps} />);
}

export default React.memo(VDPAnalytics);
